/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { QUERY_KEYS } from '@api'
import { useUser } from '@contexts'
import { ROUTE_KEYS } from '@constants'

import { UsersApi } from './api'

const onError = () => {
  notification.error({
    message: 'No pudimos encontrar el usuario',
    duration: 3,
  })
}

interface Props {
  onSucces?: () => void
}

const useLoginResponseManager = (props?: Props) => {
  const { setState } = useUser()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const { mutate, isLoading } = useMutation([QUERY_KEYS.USER], UsersApi.getUser, {
    onError,
    onSuccess: ({ user }) => {
      setState(user)
      if (props?.onSucces) props.onSucces()
      if (pathname.includes('/login') || pathname === '/') {
        navigate(ROUTE_KEYS[user.roles[0].name].HOME)
      }
    },
  })

  return { isLoading, onSucces: mutate }
}

const useUserResponseManager = (id: number | undefined) => {
  const { setState: setUser } = useUser()
  const {
    data: getUser,
    isLoading: userIsLoading,
    isFetching: userFetching,
  } = useQuery([QUERY_KEYS.USER], () => UsersApi.getUser(id), { staleTime: Infinity })

  useEffect(() => {
    if (getUser?.user) {
      setUser(getUser?.user)
    }
  }, [getUser])

  return { getUser, userIsLoading, userFetching }
}

export { useLoginResponseManager, useUserResponseManager }
